// extracted by mini-css-extract-plugin
module.exports = {"root":"EnergyUseIntensityChart_root__20oF2","yUnitLabel":"EnergyUseIntensityChart_yUnitLabel__EYuJ3"};